export default __webpack_public_path__ + "static/media/View Icon.264315f5.svg";